import { RfidGroupSearchRequest } from "../../../core/cms-api/models";
import { Pagination } from "../../../shared/models/list.page.model";
import { RfidGroupFilter } from "../store/rfid.models";
import * as paginationConstants from '../../../shared/constants/pagination.constants';


export class RfidGroupRequestUtil {
    static createRfidGroupListRequest(
        operatorId: string,
        pagination?: Pagination | null,
        filter?: RfidGroupFilter | null
    ) : RfidGroupSearchRequest {
        return {
            operatorId,
            isActive: filter?.status,
            pageIndex: pagination?.pageIndex ?? 0,
            pageSize: pagination?.pageSize ?? paginationConstants.DefaultPageSize,
        } as RfidGroupSearchRequest;
    }
}